<label class="mb-switch">
  <input type="checkbox" [checked]="checked" (change)="onToggle($event)" />
  <span class="slider"></span>
</label>
